module.exports = __webpack_public_path__ + "static/media/hero_portrait.4a5af0e7.png";